import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

function SplashImageModal(props) {
  const {
    isOpenModal,
    setIsOpenModal,
    pageTitle,
    avatar,
    setAvatar,
    description,
    setDescription,
    handleImageUpload,
    loading,
    editData,
    EditSplashImages,
    AddSplashImage,
  } = props;
  console.log(pageTitle);
  console.log(editData);
  return (
    <>
      <Modal
        isOpen={isOpenModal}
        toggle={() => setIsOpenModal(false)}
        className="custom-modal modal-width service-Modal"
      >
        <FontAwesomeIcon
          icon={faTimesCircle}
          className="close"
          onClick={() => setIsOpenModal(false)}
        />
        <h2 className="modal-title">{pageTitle}</h2>
        <hr />
      
        <input
          type="file"
          // accept="|media_type"
          onChange={handleImageUpload}
          multiple="false"
        />
        <textarea
          className="mt-2 mb-2"
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
        />
        <div className="mb-3 mt-3">
          <button
            type="button"
            className="btn btn-primary"
            // style={{ width: "unset" }}
            disabled={loading}
            onClick={(e) => {
              pageTitle == "Edit Splash Image"
                ? EditSplashImages(e, editData?.id)
                : AddSplashImage(e);
            }}
          >
            {loading ? "Loading..." : "Post"}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default SplashImageModal;
